import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { ControlCenter } from '../control-center'
import { ControlCenterDetailComponent } from '../control-center-detail/control-center-detail.component'

@Component({
  selector: 'app-control-center-detail-side',
  templateUrl: './control-center-detail-side.component.html',
  styleUrls: ['./control-center-detail-side.component.scss'],
  imports: [ControlCenterDetailComponent],
})
export class ControlCenterDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public controlCenter: ControlCenter
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.controlCenter = route.snapshot.data['controlCenter']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
